module.exports = __webpack_public_path__ + "images/icons/flags/NZ-b0805119.svg";